import {
    CREATE_PROJECT_COMMISSION_STATE,
    CREATE_PROJECT_COMMISSION_STATE_ERROR,
    CREATE_PROJECT_COMMISSION_STATE_SUCCESS,
    DELETE_PROJECT_COMMISSION_STATE,
    DELETE_PROJECT_COMMISSION_STATE_ERROR,
    DELETE_PROJECT_COMMISSION_STATE_SUCCESS,
    FETCH_PROJECT_COMMISSION_STATE,
    FETCH_PROJECT_COMMISSION_STATE_BY_ID,
    FETCH_PROJECT_COMMISSION_STATE_BY_ID_ERROR,
    FETCH_PROJECT_COMMISSION_STATE_BY_ID_SUCCESS,
    FETCH_PROJECT_COMMISSION_STATE_ERROR,
    FETCH_PROJECT_COMMISSION_STATE_SUCCESS,
    ProjectCommissionStateActionTypes,
    RESTORE_PROJECT_COMMISSION_STATE,
    RESTORE_PROJECT_COMMISSION_STATE_ERROR,
    RESTORE_PROJECT_COMMISSION_STATE_SUCCESS,
    UPDATE_PROJECT_COMMISSION_STATE,
    UPDATE_PROJECT_COMMISSION_STATE_ERROR,
    UPDATE_PROJECT_COMMISSION_STATE_SUCCESS
} from "../../actions/project-commission-state/ProjectCommissionStateActions";
import {Nullable} from "../../models/common/Nullable";
import {ProjectCommissionState} from "../../models/projects/ProjectCommissionState";
import {
    errorFetchingRequestState,
    getRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface ProjectCommissionStateReducerState {
    listEntries: {
        totalEntries: number,
        entries: Nullable< ProjectCommissionState[] >,
        request: RequestState
    }
    detailedEntries: {
        [ key: number ]: {
            entry: Nullable<ProjectCommissionState>,
            request: RequestState
        }
    },
    changingRequest: RequestState
}

const initialState: ProjectCommissionStateReducerState = {
    listEntries: {
        totalEntries: 0,
        entries: null,
        request: getRequestState()
    },
    detailedEntries: {},
    changingRequest: getRequestState()
};

export function ProjectCommissionStateReducer(
    state: ProjectCommissionStateReducerState = initialState,
    action: ProjectCommissionStateActionTypes
): ProjectCommissionStateReducerState {

    switch( action.type ) {
        case FETCH_PROJECT_COMMISSION_STATE:
            return {
                ...state,
                listEntries: {
                    ...state.listEntries,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_PROJECT_COMMISSION_STATE_SUCCESS:
            return {
                ...state,
                listEntries: {
                    totalEntries: action.payload.totalEntries,
                    entries: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_PROJECT_COMMISSION_STATE_ERROR:
            return {
                ...state,
                listEntries: {
                    ...state.listEntries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_PROJECT_COMMISSION_STATE_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.stateId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_PROJECT_COMMISSION_STATE_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.payload.stateId.rawValue ]: {
                        entry: action.payload,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_PROJECT_COMMISSION_STATE_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.stateId.rawValue ]: {
                        entry: null,
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_PROJECT_COMMISSION_STATE:
        case DELETE_PROJECT_COMMISSION_STATE:
        case RESTORE_PROJECT_COMMISSION_STATE:
        case UPDATE_PROJECT_COMMISSION_STATE:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_PROJECT_COMMISSION_STATE_SUCCESS:
        case DELETE_PROJECT_COMMISSION_STATE_SUCCESS:
        case RESTORE_PROJECT_COMMISSION_STATE_SUCCESS:
        case UPDATE_PROJECT_COMMISSION_STATE_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_PROJECT_COMMISSION_STATE_ERROR:
        case UPDATE_PROJECT_COMMISSION_STATE_ERROR:
        case DELETE_PROJECT_COMMISSION_STATE_ERROR:
        case RESTORE_PROJECT_COMMISSION_STATE_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            }
        default: return state;
    }

}